import React, { useEffect } from "react";
import BarIn from "./barIn";

const Bar = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);
  return (
    <div className="margem">
      <BarIn />
    </div>
  );
};

export default Bar;
